// extracted by mini-css-extract-plugin
export var content = "Content-module--content--MH62w";
export var contentHeadline = "Content-module--contentHeadline--Ij-YZ";
export var cardDeck = "Content-module--cardDeck--fOhAY";